import { userFirstConnect } from "@/services/admin.service";
import { searchAthlete } from "@/services/validor.service";
import type { Athlete } from "@/types/file.types";
import { errorHandler } from "@/utils/errorHandler";
import { defineStore } from "pinia";
import { useFileStore } from "./fileStore";

export const useGlobalStore = defineStore("global", {
  state: () => ({
    showLoader: false,
    ModalInfoData: {
      show: false,
      title: "",
      text: "",
      route: "",
      textlink: "",
      error: false,
      valid: false,
      rawMessage: ""
    },
    mentionChatData: {
      chatId: "",
      sender: "",
      message:""
    },
    chatUnreadMsg: 0,
    tooltip: false,
    tooltipText: "",
    tooltipPosition: null as any,
    isAdmin: false,
    userMail: "",
    userRoles: [] as string[],
    userId: "",
    userName: "",
    chatMenuOpen: false,
    showProgressLoader: false,
    showSkeletonLoading: false,
    showModalGuide: false,
    guideKey: "validation",
    searchAthletSelected: {} as Athlete,
    searchAthletList: [] as Athlete[],
    hasLoggedInBefore: true,
    isMobile: false,
    hasToken: false,
  }),

  getters: {
    isDashboardRole: (state) => state.userRoles.includes("dashboard"),
  },
  actions: {
    async athleteSearch(input: string) {
      try {
        this.searchAthletSelected = {} as Athlete;
        let res = await searchAthlete("FOR_LINK", 1, 3, input);
        if (!res) {
          console.log("No athletes to find.");
          return;
        }
        const fileStore = useFileStore();
        this.searchAthletList = res.items.filter(
          (athlete) => athlete.id !== fileStore.athlete.id
        );
        return;
      } catch (error) {
        if (error instanceof Error) {
          errorHandler(error);
        }
      }
    },
    async updateUserName() {
      try {
        await userFirstConnect(this.userId, this.userName);
        if (this.userRoles.includes("validator")) {
          this.guideKey = "validation";
          this.showModalGuide = true;
        } else if (this.userRoles.includes("editor")) {
          this.guideKey = "editor";
          this.showModalGuide = true;
        }
        this.hasLoggedInBefore = true;
      } catch (error) {
        if (error instanceof Error) {
          errorHandler(error);
        }
      }
    },
    emptyModalInfoData() {
      this.ModalInfoData = {
        show: false,
        title: "",
        text: "",
        route: "",
        textlink: "",
        error: false,
        valid: false,
        rawMessage: ""
      };
    }
  },
});
